import { render, staticRenderFns } from "./GerenciarPacientes.vue?vue&type=template&id=4917b278&scoped=true"
import script from "./GerenciarPacientes.vue?vue&type=script&lang=js"
export * from "./GerenciarPacientes.vue?vue&type=script&lang=js"
import style0 from "./GerenciarPacientes.vue?vue&type=style&index=0&id=4917b278&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4917b278",
  null
  
)

export default component.exports